import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row mb-3" }
const _hoisted_3 = { class: "col-md-2" }
const _hoisted_4 = ["value"]
const _hoisted_5 = { class: "col-md-2" }
const _hoisted_6 = { class: "col-md-2" }
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "col-md-2" }
const _hoisted_9 = { class: "col-md-2" }
const _hoisted_10 = { class: "col-md-2" }
const _hoisted_11 = { class: "mb-3" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = { class: "ms-3" }
const _hoisted_14 = { class: "changed" }
const _hoisted_15 = { class: "text-muted" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_pagination = _resolveComponent("b-pagination")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[16] || (_cache[16] = _createElementVNode("h1", null, "Журнал аудита", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[9] || (_cache[9] = _createElementVNode("label", { class: "form-label" }, "Таблица", -1)),
        _withDirectives(_createElementVNode("select", {
          class: "form-control",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.params.tableName) = $event))
        }, [
          _cache[8] || (_cache[8] = _createElementVNode("option", { value: null }, "Все", -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tables, (t) => {
            return (_openBlock(), _createElementBlock("option", {
              key: t.value,
              value: t.value
            }, _toDisplayString(t.label), 9, _hoisted_4))
          }), 128))
        ], 512), [
          [_vModelSelect, _ctx.params.tableName]
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _cache[10] || (_cache[10] = _createElementVNode("label", { class: "form-label" }, "ID записи", -1)),
        _withDirectives(_createElementVNode("input", {
          class: "form-control",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.params.rowId) = $event))
        }, null, 512), [
          [_vModelText, _ctx.params.rowId]
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _cache[12] || (_cache[12] = _createElementVNode("label", { class: "form-label" }, "Действие", -1)),
        _withDirectives(_createElementVNode("select", {
          class: "form-control",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.params.action) = $event))
        }, [
          _cache[11] || (_cache[11] = _createElementVNode("option", { value: null }, "Все", -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.actions, (a) => {
            return (_openBlock(), _createElementBlock("option", {
              key: a,
              value: a
            }, _toDisplayString(a), 9, _hoisted_7))
          }), 128))
        ], 512), [
          [_vModelSelect, _ctx.params.action]
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _cache[13] || (_cache[13] = _createElementVNode("label", { class: "form-label" }, "Пользователь (ID)", -1)),
        _withDirectives(_createElementVNode("input", {
          class: "form-control",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.params.userId) = $event))
        }, null, 512), [
          [_vModelText, _ctx.params.userId]
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _cache[14] || (_cache[14] = _createElementVNode("label", { class: "form-label" }, "С", -1)),
        _withDirectives(_createElementVNode("input", {
          type: "date",
          class: "form-control",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.fromDate) = $event))
        }, null, 512), [
          [_vModelText, _ctx.fromDate]
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _cache[15] || (_cache[15] = _createElementVNode("label", { class: "form-label" }, "По", -1)),
        _withDirectives(_createElementVNode("input", {
          type: "date",
          class: "form-control",
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.toDate) = $event))
        }, null, 512), [
          [_vModelText, _ctx.toDate]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("button", {
        class: "btn btn-primary",
        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.fetch(true))),
        disabled: _ctx.loading
      }, _toDisplayString(_ctx.loading ? "Загрузка..." : "Поиск"), 9, _hoisted_12),
      _createElementVNode("span", _hoisted_13, "Найдено: " + _toDisplayString(_ctx.total), 1)
    ]),
    _createVNode(_component_b_pagination, {
      modelValue: _ctx.currentPage,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.currentPage) = $event)),
      "total-rows": _ctx.total,
      "per-page": _ctx.params.pageSize
    }, null, 8, ["modelValue", "total-rows", "per-page"]),
    _createVNode(_component_el_table, {
      data: _ctx.entries,
      style: {"width":"100%"},
      border: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, { type: "expand" }, {
          default: _withCtx((props) => [
            _createElementVNode("pre", _hoisted_14, _toDisplayString(_ctx.prettyChanged(props.row.changed)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Когда",
          width: "170"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(_ctx.formatDate(scope.row.occurredAt)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Кто",
          width: "200"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", null, _toDisplayString(scope.row.userName || scope.row.userId), 1),
            _createElementVNode("small", _hoisted_15, _toDisplayString(scope.row.actor) + " · " + _toDisplayString(scope.row.ip), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "action",
          label: "Действие",
          width: "120"
        }),
        _createVNode(_component_el_table_column, {
          prop: "tableName",
          label: "Объект",
          width: "230"
        }),
        _createVNode(_component_el_table_column, {
          prop: "rowId",
          label: "ID",
          width: "120"
        }),
        _createVNode(_component_el_table_column, {
          prop: "reason",
          label: "Причина"
        }),
        _createVNode(_component_el_table_column, {
          prop: "requestId",
          label: "Запрос",
          width: "140"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("small", null, _toDisplayString(scope.row.requestId), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"])
  ]))
}